// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__247Au","title":"ClientReferral_title__27o25","itemText":"ClientReferral_itemText__caMhw"};